module.exports = __webpack_public_path__ + "static/media/slide-1-mobile.ac52eda3.png";